<template>
  <div class="panel">
    <p>{{$t('board.partager') }}</p>
    <br />
    <vue-tags-input
      class="UserList__input"
      :placeholder="$t('board.shares.placeholder')"
      :autocomplete-items="suggestions"
      v-model="query"
      :tags="tags"
      avoid-adding-duplicates
      @adding-duplicate="error_email.double = true;"
      @tags-changed="update"
      @before-adding-tag="checkEmail"
    >
      <template slot="autocomplete-header">
        <strong>{{ $t('suggestions') }}</strong>
      </template>
      <div
        slot="autocomplete-item"
        slot-scope="props"
        class="UserList__search-items"
        :class="{ notActivated: !props.item.activated, noLicence: !props.item.hasLicence }"
        @click="props.performAdd(props.item)"
      >
        <div style="width: 50px">
          <img
            style="border-radius:50%;max-width:30px;"
            :src="imageProfil(props.item.picture)"
            alt="img-user"
          />
        </div>
        <div class="UserListRow__infos">
          <span
            style="font-weight: 700;"
            v-if="props.item.name.length > 1"
          >{{ props.item.name }}</span>
          <span
            style="font-style: italic;"
            v-else
          >{{ $t('title.guestUser') }}</span>
          <span style="float: right;">
            <b-tooltip
              v-if="props.item.hasLicence === false"
              :label="$t('user.noLicence', { outil: capitaliseOutil })"
              position="is-right"
              type="is-dark"
            >
              <b-icon
                icon="exclamation-circle"
                size="is-small"
              />
            </b-tooltip>
          </span>

          <br />
          <span>{{ props.item.text }}</span>
          <small
            style="float: right;"
            v-if="!props.item.activated"
          >{{ $t('user.notactivated') }}</small>
        </div>
      </div>
    </vue-tags-input>
    <div style="min-height: 20px;">
      <transition name="slide-fade">
        <small
          class="error_email"
          v-if="error_email.invalid"
        >
          <b-icon
            icon="exclamation-circle"
            size="is-small"
          />
          {{ $t('error.email.invalid') }}
        </small>
      </transition>
      <transition name="slide-fade">
        <small
          class="error_email"
          v-if="error_email.double"
        >
          <b-icon
            icon="exclamation-circle"
            size="is-small"
          />
          {{ $t('error.email.double') }}
        </small>
      </transition>
      <transition name="slide-fade">
        <small
          class="error_email"
          v-if="error_email.yours"
        >
          <b-icon
            icon="exclamation-circle"
            size="is-small"
          />
          {{ $t('error.email.yours') }}
        </small>
      </transition>
    </div>

    <span
      slot="footer"
      class="dialog-footer"
      style="margin-top: 25px"
    >
      <button
        style="margin-right:10px"
        @click="$parent.close()"
        class="button"
      >{{ $t('button.annuler') }}</button>
      <button
        type="is-success"
        class="is-success button"
        @click="shareButton()"
      >{{ $tc('button.validate') }}</button>
    </span>
    <!-- <b-loading
      is-primary
      is-full-page
      :active.sync="pending"
    ></b-loading> -->
  </div>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input'
import axios from 'axios'
import debounce from 'lodash.debounce'

function isEmail (email) {
  const regEmail = new RegExp(
    '^[0-9a-z._-]{2,64}@{1}[0-9a-z.-]{2,}[.]{1}[a-z]{2,}$',
    'i'
  )
  return regEmail.test(email)
}

export default {
  props: ['board_id'],
  components: {
    VueTagsInput
  },
  name: 'PopupShares',
  data () {
    return {
      tool: 'brainstormin',
      suggestions: [],
      tags: [],
      query: '',
      pending: false,
      error_email: {
        invalid: false,
        double: false,
        yours: false
      }
    }
  },
  computed: {
    capitaliseOutil () {
      return this.tool.replace(/^\w/, c => c.toUpperCase())
    }
  },
  watch: {
    query () {
      this.error_email = {
        invalid: false,
        double: false,
        yours: false
      }
      this.search()
    }
  },
  mounted () {
    this.pending = true
    axios.defaults.headers.common['Authorization'] =
      'Bearer ' + this.$store.state.auth.token
    axios
      .get(`${process.env.URL_SSO_API}Share/${this.tool}/${this.board_id}`)
      .then(response => {
        this.tags = response.data.map(query => {
          return { text: query.email }
        })
        this.pending = false
      })
  },
  methods: {
    imageProfil (pictureUrl) {
      let url = process.env.URL_SSO_API.replace('api/v1/', '')
      if (pictureUrl) {
        return url + pictureUrl
      } else {
        return url + '/uploads/appy/user/default-user-picture.png'
      }
    },
    shareButton () {
      if (!this.query.trim().length || isEmail(this.query.toLowerCase())) {
        const shares = this.tags.map(a => {
          return a.text
        })
        const data = new FormData()
        data.append('_method', 'PUT')
        data.append('shares', shares)
        this.pending = true
        axios
          .post(
            `${process.env.URL_SSO_API}Share/${this.tool}/${this.board_id}`,
            data
          )
          .then(response => {
            this.$parent.close()
            this.pending = false
            this.$buefy.toast.open({
              type: 'is-success',
              message: this.$i18n.t('toast.shares')
            })
          })
      } else {
        this.error_email.invalid = true
      }
    },
    checkEmail (obj) {
      let email = obj.tag.text
      if (email && this.$store.getters['auth/currentUserEmail'] === email) {
        this.error_email.yours = true
      } else if (email && isEmail(email)) {
        obj.tag.text = email.toLowerCase()
        obj.addTag()
      } else {
        this.error_email.invalid = true
      }
    },
    update (newTags) {
      this.suggestions = []
      this.tags = newTags
    },
    search: debounce(async function () {
      if (this.query.length < 3) return (this.suggestions = [])

      axios.defaults.headers.common['Authorization'] =
        'Bearer ' + this.$store.state.auth.token
      axios
        .get(
          `${process.env.URL_SSO_API}user/suggestion?orderBy=email,asc&fields=id,email,firstname,lastname,picture_url,group_id&paginate=15&page=1&q=${this.query}`
        )
        .then(response => {
          // on vérifie si l'utilisateur a son email dans la liste des shares et si c'est le cas on l'enleve
          let new_suggestions = response.data.filter(
            user => user.email !== this.$store.getters['auth/currentUserEmail']
          )

          // nouvelle object retourné dans les suggestions avec seulement les infos necessaires
          this.suggestions = new_suggestions.map(user => {
            const licence = user.licences.some(
              app => app.toLowerCase() == this.tool
            )
            return {
              text: user.email,
              name: user.firstname + ' ' + user.lastname,
              picture: user.picture_url,
              activated: user.activated,
              hasLicence: licence
            }
          })
        })
    }, 500)
  }
}
</script>

<style scoped lang="css">
.panel {
  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: white;
  padding: 3em;
  border-radius: 10px;
}

.UserList__input {
  width: 100%;
  height: 100%;
  margin: 0;
  z-index: 10;
}
.UserList__input div {
  border-radius: 5px;
}
.UserList__input li.ti-selected-item {
  background-color: #f5f7fa;
  color: #4e5053be;
}

.UserList__input li.ti-selected-item:hover {
  background-color: #f5f7fa;
}

.UserList__input li.ti-tag {
  border-radius: 3px;
  background-color: #f5f5f5;
  color: #4e5053;
}

.UserList__search-items {
  display: flex;
}

.notActivated {
  background-color: #f6f7f896; /* rgba(231, 231, 231, 0.568); */
  color: rgba(165, 165, 165, 0.555);
}

.UserListRow__profil-picture {
  border-radius: 50%;
  margin: 0 10px;
  width: 30px;
  height: 30px;
}

.UserListRow__infos {
  width: 100%;
  font-size: 12px;
}

.UserList__tag-picture {
  border-radius: 50%;
  margin-top: 1px;
  margin-right: 5px;
  width: 30px;
  height: 30px;
}

.error_email {
  color: red;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/PopupShares.vue